import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import {
  BranchItem,
  BranchList,
  BranchState,
  SelectedBranchLocation,
  ServiceAreaItem,
  SpecialityItem,
} from '../types/store.types';

const initialState: BranchState = {
  isBranchModal: false,
  branchList: {
    getBranchList: [],
  },
  searchedBranchList: [],
  specilityItemList: [],
  serviceAreaItemList: [],
  active: true,
  selectedBranch: '',
  selectedBranchLocation: {
    cityName: '',
    stateName: '',
    branchName: '',
    orgId: '',
    allAuthorities: [],
  },
};

export const branchSlice = createSlice({
  name: 'branch',
  initialState,
  reducers: {
    updateActiveStatus: (state, action: PayloadAction<boolean>) => {
      state.active = action.payload;
    },
    getBranchTableList: (state, action: PayloadAction<BranchList>) => {
      state.branchList = action.payload;
    },
    updateBranchList: (state, action: PayloadAction<BranchItem>) => {
      const reduxState = current(state);
      const branchList = reduxState?.branchList?.getBranchList;
      const index = branchList.findIndex((item) => item?.id === action?.payload?.id);
      const updatedData = { ...branchList[index], ...action?.payload };
      const updatedBranchList = [...branchList];
      updatedBranchList?.splice(index, 1, updatedData);
      state.branchList = { getBranchList: updatedBranchList };
    },
    deleteItemBranchList: (state, action: PayloadAction<{ id: string }>) => {
      const reduxState = current(state);
      const branchList = reduxState?.branchList?.getBranchList;
      const index = branchList.findIndex((item: { id: string }) => item?.id === action?.payload?.id);
      const updatedBranchList = [...branchList];
      updatedBranchList?.splice(index, 1);
      state.branchList = { getBranchList: updatedBranchList };
    },
    getSearchedBranchTableList: (state, action: PayloadAction<BranchItem[]>) => {
      state.searchedBranchList = action.payload;
    },
    updateSelectedBranchList: (state, action: PayloadAction<BranchItem>) => {
      const reduxState = current(state);
      const branchList = reduxState?.searchedBranchList;
      const index = branchList.findIndex((item) => item?.id === action?.payload?.id);
      const updatedData = { ...branchList[index], ...action?.payload };
      const updatedBranchList = [...branchList];
      updatedBranchList?.splice(index, 1, updatedData);
      state.searchedBranchList = updatedBranchList;
    },
    deleteItemSelectedBranchList: (state, action: PayloadAction<{ id: string }>) => {
      const reduxState = current(state);
      const branchList = reduxState?.searchedBranchList;
      const index = branchList.findIndex((item: { id: string }) => item?.id === action?.payload?.id);
      const updatedBranchList = [...branchList];
      updatedBranchList?.splice(index, 1);
      state.searchedBranchList = updatedBranchList;
    },
    updateSelectedBranch: (state, action: PayloadAction<string>) => {
      state.selectedBranch = action.payload;
    },
    updateSelectedBranchLocation: (state, action: PayloadAction<SelectedBranchLocation>) => {
      state.selectedBranchLocation = {
        cityName: action.payload.cityName,
        stateName: action.payload.stateName,
        branchName: action.payload.branchName,
        orgId: action.payload.orgId,
        allAuthorities: action.payload ? action.payload.allAuthorities : [],
      };
    },
    getSpecialityItems: (state, action: PayloadAction<(SpecialityItem | undefined)[] | undefined>) => {
      state.specilityItemList = action.payload;
    },
    getServiceArea: (state, action: PayloadAction<(ServiceAreaItem | undefined)[] | undefined>) => {
      state.serviceAreaItemList = action.payload;
    },
  },
});

export const branchActions = branchSlice.actions;

export default branchSlice.reducer;
